import React from 'react';
import { Alert } from 'react-bootstrap';

function QueueTabPlaceholder({ queueType }) {
    return (
        <Alert variant="info" className="mb-0">
            <i className="bi bi-info-circle me-2"></i>
            <strong>{queueType} Queue</strong> will be available here soon. Email and SMS queues are fully implemented — switch to those tabs to manage queued messages.
        </Alert>
    );
}

export default QueueTabPlaceholder;
